import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import router from './router'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n';
import messages from './i18n/index.js';
import Vue3TouchEvents from "vue3-touch-events";


const pinia = createPinia()

const savedLocale = localStorage.getItem('locale') || 'en'

const i18n = createI18n({
    legacy: false,
    locale: savedLocale,
    fallbackLocale: 'en',
    messages,
  })

const app = createApp(App);

app.use(i18n);
app.use(vuetify);
app.use(router);
app.use(pinia);
app.use(Vue3TouchEvents);
app.mount('#app');